import { Popover, Typography } from "antd-v5";
import { useGlobalSettingsContext } from "contexts/GlobalSettingsContext";
import { isNil } from "lodash";
import React, { useCallback } from "react";
import FindingAPI from "restAPI/FindingAPI";
import { ARMORCODE_GROUP_KEY } from "utils/armorcodeGroupUtil";
import {
  RISK_SCORE_DOC_LINK,
  RiskScoreDisableTag,
  getRiskScorePopoverTitleProps,
} from "utils/riskScoreUtil";

import ACRiskScoreTag from "ac-components/ac-riskscore-tag/ACRiskScoreTag";

import FindingRiskScorePopover from "./FindingRiskScorePopover";
import Vocabulary from "./Vocabulary";

const RiskScoreCellData = ({
  riskScore,
  record,
  filters,
  column,
  riskScoreType,
}) => {
  const fetchFinding = useCallback(() => {
    const isHierarchy = column === ARMORCODE_GROUP_KEY;
    const newFilters = { ...filters };

    const isTagColumn = column === "tags";
    if (isTagColumn) {
      newFilters.keyValue = [
        ...(newFilters.keyValue || []),
        {
          key: record.name.includes(":")
            ? `"${record.name.slice(0, record.name.indexOf(":"))}"`
            : `""`,
          value: record.name.includes(":")
            ? `"${record.name.slice(record.name.indexOf(":") + 1)}"`
            : '""',
        },
      ];
    }

    return FindingAPI.getAll({
      filters: isTagColumn
        ? {
            ...newFilters,
          }
        : {
            ...filters,
            [isHierarchy ? "groups" : column]: [
              isHierarchy && record.group ? record.group : record.name,
            ],
            ...(record.name === "null" ? { [column]: [null] } : {}),
          },
      page: 0,
      size: 1,
      sortColumns: [{ property: "riskScore", direction: "desc" }],
    });
  }, [filters, column, record]);

  const { riskScoreEnabled } = useGlobalSettingsContext();

  if (!riskScoreEnabled) {
    return <RiskScoreDisableTag />;
  }

  const riskScoreTag = <ACRiskScoreTag value={riskScore} />;

  if (isNil(riskScore)) {
    return riskScoreTag;
  }
  if (riskScoreType === "mean") {
    return (
      <MeanRiskScorePopover riskScore={riskScore}>
        {riskScoreTag}
      </MeanRiskScorePopover>
    );
  }
  return (
    <FindingRiskScorePopover fetchFinding={fetchFinding} showFindingLink>
      {riskScoreTag}
    </FindingRiskScorePopover>
  );
};

const MeanRiskScorePopover = ({ children, riskScore }) => {
  const { riskScoreRange } = useGlobalSettingsContext();
  const popoverTitleProps = getRiskScorePopoverTitleProps(
    riskScore,
    true,
    riskScoreRange,
    true,
  );
  return (
    <Popover
      content={
        <div>
          <Typography.Text
            strong
            className={`${popoverTitleProps.titleStyle}-text m-b-xs`}
          >
            {popoverTitleProps.title}
          </Typography.Text>
          <br />
          <>Average <Vocabulary name="riskScore"/> of all findings under this finding group.</>
          <div className="d-flex justify-content-flex-end tag-tooltip-doc-link">
            {RISK_SCORE_DOC_LINK}
          </div>
        </div>
      }
    >
      {children}
    </Popover>
  );
};

export default RiskScoreCellData;
